/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{flex:auto;display:flex;position:relative}[_nghost-%COMP%] > div[_ngcontent-%COMP%]{flex:auto;position:absolute;top:0;bottom:0;left:0;right:0;flex-direction:column;display:flex;overflow:auto}.options[_ngcontent-%COMP%]{display:flex}.options[_ngcontent-%COMP%]   .option[_ngcontent-%COMP%]{margin:.5em}"];
export { styles as styles };
